import { onValue, ref } from "firebase/database";
import { database } from "../firebase/initFirebase";
import { BlogData } from "../../hooks/react-query/useBlogList";

export function fetchBlog(slug: string, locale: string): Promise<BlogData | null> {
  const publishedBlogRef = ref(database, `published/blog/${locale}/${slug}`);
  return new Promise((resolve, reject) => {
    onValue(
        publishedBlogRef,
        async (snapshot) => {
          const publishedEntries: BlogData = snapshot.val();
          resolve(publishedEntries);
        },
        (error) => {
          reject(error);
        }
    );
  });
}

export function fetchAllBlogs(locale?: string): Promise<Record<string, BlogData> | null> {
  const publishedBlogRef = ref(database, locale ?  `published/blog/${locale}` : `published/blog`);
  return new Promise((resolve, reject) => {
    onValue(
        publishedBlogRef,
        async (snapshot) => {
          const publishedEntries: Record<string, BlogData> | null =
              snapshot.val();
          resolve(publishedEntries);
        },
        (error) => {
          reject(error);
        }
    );
  });
}

export function filterBlogsByAuthor(
    blogs: Record<string, BlogData>,
    authorSlug: string
): Record<string, BlogData> {
  const authorBlogs: Record<string, BlogData> = {};
  Object.keys(blogs)
      .sort((a, b) => a.localeCompare(b))
      .map((key, index) => {
        const blog = blogs[key];
        if (blog.specialistUrl === authorSlug) {
          authorBlogs[key] = blogs[key];
        }
      });
  return authorBlogs;
}


// import { BlogData } from "../../hooks/react-query/useBlogList";
// import { WP_CMS } from "../../constants/env";
// import {
//   CategoryConnection,
//   Post,
//   TagConnection,
//   UserConnection,
// } from "../../types/graphql";
//
// export interface BlogPostData {
//   data: {
//     post: Post;
//   };
// }
//
// export interface UsersWithData {
//   data: {
//     users: UserConnection;
//   };
// }
//
// export interface TagsWithData {
//   data: {
//     tags: TagConnection;
//   };
// }
//
// export interface CategoryWithData {
//   data: {
//     categories: CategoryConnection;
//   };
// }
//
// function allPostsQuery(locale: string, first?: number) {
//   return {
//     query: `query fetchAllPosts {
//   posts(first: ${
//     first ? first : 1000
//   }, where: {categoryName: "blog-${locale}"}) {
//     nodes {
//       id
//       slug
//     }
//   }
// }`,
//   };
// }
//
// function postQuery(id: string) {
//   return {
//     query: `query fetchPost {
//   post(id: "${id}", , idType: SLUG) {
//     title
//     id
//     content
//     slug
//  seo {
//       breadcrumbTitle
//       canonicalUrl
//       description
//       title
//       jsonLd {
//         raw
//       }
//       robots
//       focusKeywords
//       openGraph {
//         description
//         articleMeta {
//           author
//           modifiedTime
//           publishedTime
//           section
//           publisher
//           tags
//         }
//         alternateLocales
//         facebookMeta {
//           admins
//           appId
//         }
//         image {
//           secureUrl
//           height
//           type
//           url
//           width
//         }
//         locale
//         siteName
//         slackEnhancedData {
//           data
//           label
//         }
//         title
//         twitterMeta {
//           appCountry
//           card
//           creator
//           description
//           googleplayApp {
//             id
//             name
//             url
//           }
//           image
//           ipadApp {
//             id
//             name
//             url
//           }
//           iphoneApp {
//             id
//             name
//             url
//           }
//           playerStream
//           playerStreamContentType
//           playerUrl
//           site
//           title
//         }
//         type
//         updatedTime
//         url
//         videoMeta {
//           duration
//           url
//         }
//       }
//     }
//     featuredImage {
//       node {
//         sourceUrl
//       }
//     }
//     categories {
//       nodes {
//         categoryId
//         name
//       }
//     }
//     tags {
//       nodes {
//         id
//         name
//         slug
//       }
//     }
//     categories {
//       nodes {
//         id
//         name
//         slug
//       }
//     }
//     author {
//       node {
//         slug
//         id
//         name
//         avatar {
//           url
//         }
//       }
//     }
//   }
// }`,
//   };
// }
//
// function allAuthorsWithPostsQuery(
//   locale: string,
//   slug: string,
//   first?: number
// ) {
//   return {
//     query: `query fetchAllAuthorPosts {
//  users(first:999, where: {nicename: "${slug}"}) {
//   ${genericPostQuery(locale, first)}
//   }
// }`,
//   };
// }
//
// function allTagsWithPostsQuery(locale: string, slug: string) {
//   return {
//     query: `query fetchAllTagPosts {
//  tags(first:999, where: {slug: "${slug}"}) {
//   ${genericPostQuery(locale)}
//   }
// }`,
//   };
// }
//
// function allCategoriesWithPostsQuery(
//   locale: string,
//   slug: string,
//   first?: number
// ) {
//   return {
//     query: `query fetchAllCategoryPosts {
//  categories(first: 999, where: {slug: "${slug}"}) {
//   ${genericPostQuery(locale, first)}
//   }
// }`,
//   };
// }
//
// function tagQuery(slug: string) {
//   return {
//     query: `query fetchAllTagPosts {
//  tags(where: {slug: "${slug}"}) {
//  edges {
//   node {
//     name
//    }
//    }
//   }
// }`,
//   };
// }
//
// function categoryQuery(slug: string) {
//   return {
//     query: `query fetchAllTagPosts {
//  categories(where: {slug: "${slug}"}) {
//  edges {
//   node {
//     name
//    }
//    }
//   }
// }`,
//   };
// }
//
// function genericPostQuery(locale: string, first?: number) {
//   return `
//      edges {
//       node {
//         id
//         posts(first: ${
//           first ? first : 999
//         }, where: {categoryName: "/blog-${locale}"}) {
//             nodes {
//       id
//       excerpt
//       slug
//       author {
//         node {
//           avatar {
//             url
//           }
//           slug
//           name
//           id
//         }
//       }
//       featuredImage {
//         node {
//           sourceUrl
//         }
//       }
//       tags {
//         nodes {
//           name
//         }
//       }
//       categories {
//         nodes {
//           name
//         }
//       }
//       modified
//       postId
//       title
//     }
//         }
//       }
//     }`;
// }
//
// function allAuthors() {
//   return {
//     query: `query fetchAllAuthors {
//  users(where: {}) {
//     edges {
//       node {
//         id
//         slug
//       }
//     }
//   }
// }`,
//   };
// }
//
// function allTags() {
//   return {
//     query: `query fetchAllTags {
//  tags(where: {}) {
//     edges {
//       node {
//         id
//         slug
//       }
//     }
//   }
// }`,
//   };
// }
//
// function allCategories() {
//   return {
//     query: `query fetchAllTags {
//  categories(where: {}) {
//     edges {
//       node {
//         id
//         slug
//       }
//     }
//   }
// }`,
//   };
// }
//
// export async function fetchAllPostsFromWP(
//   locale: string,
//   first?: number
// ): Promise<BlogData> {
//   const request = await fetch(WP_CMS, {
//     method: "POST",
//     headers: {
//       "Content-type": "application/json",
//     },
//     body: JSON.stringify(allPostsQuery(locale, first)),
//   });
//
//   return await request.json();
// }
//
// export async function fetchPostFromWP(id: string): Promise<BlogPostData> {
//   const request = await fetch(WP_CMS, {
//     method: "POST",
//     headers: {
//       "Content-type": "application/json",
//     },
//     body: JSON.stringify(postQuery(id)),
//   });
//
//   return await request.json();
// }
//
// export async function filterBlogsByAuthor(
//   locale: string,
//   slug: string,
//   first?: number
// ): Promise<UsersWithData> {
//   const request = await fetch(WP_CMS, {
//     method: "POST",
//     headers: {
//       "Content-type": "application/json",
//     },
//     body: JSON.stringify(allAuthorsWithPostsQuery(locale, slug, first)),
//   });
//
//   return await request.json();
// }
//
// export async function filterBlogsByTag(
//   locale: string,
//   slug: string
// ): Promise<TagsWithData> {
//   const request = await fetch(WP_CMS, {
//     method: "POST",
//     headers: {
//       "Content-type": "application/json",
//     },
//     body: JSON.stringify(allTagsWithPostsQuery(locale, slug)),
//   });
//
//   return await request.json();
// }
//
// export async function filterBlogsByCategory(
//   locale: string,
//   slug: string,
//   first?: number
// ): Promise<CategoryWithData> {
//   const request = await fetch(WP_CMS, {
//     method: "POST",
//     headers: {
//       "Content-type": "application/json",
//     },
//     body: JSON.stringify(allCategoriesWithPostsQuery(locale, slug, first)),
//   });
//
//   return await request.json();
// }
//
// export async function getAllAuthors(): Promise<UsersWithData> {
//   const request = await fetch(WP_CMS, {
//     method: "POST",
//     headers: {
//       "Content-type": "application/json",
//     },
//     body: JSON.stringify(allAuthors()),
//   });
//
//   return await request.json();
// }
//
// export async function getAllTags(): Promise<TagsWithData> {
//   const request = await fetch(WP_CMS, {
//     method: "POST",
//     headers: {
//       "Content-type": "application/json",
//     },
//     body: JSON.stringify(allTags()),
//   });
//
//   return await request.json();
// }
//
// export async function getTag(slug: string): Promise<TagsWithData> {
//   const request = await fetch(WP_CMS, {
//     method: "POST",
//     headers: {
//       "Content-type": "application/json",
//     },
//     body: JSON.stringify(tagQuery(slug)),
//   });
//
//   return await request.json();
// }
//
// export async function getAllCategories(): Promise<CategoryWithData> {
//   const request = await fetch(WP_CMS, {
//     method: "POST",
//     headers: {
//       "Content-type": "application/json",
//     },
//     body: JSON.stringify(allCategories()),
//   });
//
//   return await request.json();
// }
//
// export async function getCategory(slug: string): Promise<CategoryWithData> {
//   const request = await fetch(WP_CMS, {
//     method: "POST",
//     headers: {
//       "Content-type": "application/json",
//     },
//     body: JSON.stringify(categoryQuery(slug)),
//   });
//
//   return await request.json();
// }
